import * as ActionTypes from './actionTypes';

export function updateComponentState(type, payload) {
  return { type, payload };
}

export function setTitle(title) {
  return { type: ActionTypes.SET_TITLE, payload: { title: title } };
}

export function setUserDetails(userDetails) {
  return { type: ActionTypes.SET_LOGIN_DETAILS, payload: { userDetails: userDetails } };
}

export function resetSession302() {
  return { type: ActionTypes.SESSION_EXPIRED_302_RESET };
}

export function setBPUserAuthDetails(authDetails) {
  return { type: ActionTypes.SET_BP_USER_AUTH_DETAILS, payload: authDetails };
}

export const setNotificationsClientId = data => {
  return { type: ActionTypes.SET_NOTIFICATIONS_CLIENTID, data };
};
export function setUserPasswordlessStatus(statusDetails) {
  return { type: ActionTypes.PASSWORDLESS_STATUS, payload: statusDetails };
}
